import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective } from 'ngx-mask';
import { GestorMunicipalService } from '../../../shared/services/gestor-municipal.service';
import { AlertService } from '../../../shared/services/alert.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-cadastro-gestor-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './cadastro-gestor-modal.component.html',
  styleUrl: './cadastro-gestor-modal.component.scss',
})
export class CadastroGestorModalComponent {
  activeModal = inject(NgbActiveModal);
  private fb = inject(FormBuilder);
  private gestorService = inject(GestorMunicipalService);
  private alertService = inject(AlertService);
  private readonly cdr = inject(ChangeDetectorRef);

  form: FormGroup = this.fb.group({
    cnpj: ['', [Validators.required, Validators.minLength(14)]],
    cpf: ['', [Validators.required, Validators.minLength(11)]],
  });

  carregando = false;

  get cnpjInvalido(): boolean {
    const ctrl = this.form.get('cnpj');
    return !!(ctrl?.invalid && ctrl.touched);
  }

  get cpfInvalido(): boolean {
    const ctrl = this.form.get('cpf');
    return !!(ctrl?.invalid && ctrl.touched);
  }

  cadastrar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.carregando = true;

    const { cnpj, cpf } = this.form.value;

    this.gestorService
      .cadastrar({ cnpj, cpf })
      .pipe(
        finalize(() => {
          this.carregando = false;
          this.cdr.detectChanges();
        }),
      )
      .subscribe({
        next: (response) => {
          this.alertService.success(
            `Gestor ${response.nome} cadastrado com sucesso!`,
          );
          this.activeModal.close(response);
        },
        error: (err) => {
          this.carregando = false;
          const mensagem =
            err?.error?.message || 'Erro ao cadastrar gestor. Tente novamente.';
          this.alertService.error(mensagem);
          this.cdr.detectChanges();
        },
      });
  }

  fechar(): void {
    this.activeModal.dismiss();
  }
}
